import { AnimatePresence } from 'framer-motion';
import React, { KeyboardEventHandler, useEffect, useRef, useState } from 'react';
import useMoveLast from 'hooks/useMoveLast';
import {
	ButtonInputBox,
	ButtonWrapper,
	HelperText,
	helper_ani,
	InputBoxWrapper,
	InputWrapper,
	LabelText,
} from './style';
import { IButtonInput } from './type';

const CoreButtonInput = ({
	input_id,
	is_error = false,
	_placeholder,
	_disabled = false,
	label,
	helper,
	another_type,
	_onClick,
	_width = '100%',
	_onChange,
	_onKeyDown: _,
	_value,
	_ref,
	children,
	_margin,
}: IButtonInput) => {
	const inputbox_ref = useRef<HTMLInputElement>(null);
	const button_wrapper_ref = useRef<HTMLSpanElement>(null);

	const [button_size, setButtonSize] = useState(0);

	// input창 클릭 시 커서가 입력한 제일 마지막 값으로 이동하는 커스텀 훅
	useMoveLast(_ref ?? inputbox_ref);

	useEffect(() => {
		if (button_wrapper_ref.current === null) return;

		const target = button_wrapper_ref.current?.getElementsByTagName('button')?.[0];

		if (!target) return;

		setButtonSize(target.offsetWidth);
	}, [button_wrapper_ref]);

	const enterEvent: KeyboardEventHandler = (e) => {
		if (e.key !== 'Enter') return;

		const target = e.currentTarget;

		if (!target) return;

		const button = target?.nextSibling?.firstChild as HTMLElement;

		if (!button) return;

		button.click();
	};

	return (
		<InputWrapper _width={_width} _margin={_margin} onClick={(e) => e.stopPropagation()}>
			<LabelText input_id={input_id} is_label={label ? true : false}>
				{label}
			</LabelText>
			<InputBoxWrapper>
				<ButtonInputBox
					type={another_type ?? 'text'}
					placeholder={_placeholder}
					disabled={_disabled}
					id={input_id}
					is_error={is_error}
					ref={_ref ?? inputbox_ref}
					button_size={button_size}
					value={_value}
					onChange={_onChange}
					// onKeyDown={_onKeyDown}
					onKeyDown={enterEvent}
				/>
				<ButtonWrapper onClick={_onClick} ref={button_wrapper_ref}>
					{children}
				</ButtonWrapper>
			</InputBoxWrapper>
			<AnimatePresence>
				{helper && helper !== '' && (
					<HelperText
						is_error={is_error ? 'true' : 'false'}
						variants={helper_ani}
						initial="init"
						animate="ani"
						exit="exit"
					>
						{helper}
					</HelperText>
				)}
			</AnimatePresence>
		</InputWrapper>
	);
};

export default CoreButtonInput;
